__turbopack_context__.v({
  "acheivername": "why-shankar-ias-module__RMjqfa__acheivername",
  "acheiverrank": "why-shankar-ias-module__RMjqfa__acheiverrank",
  "cardBox": "why-shankar-ias-module__RMjqfa__cardBox",
  "classesborder": "why-shankar-ias-module__RMjqfa__classesborder",
  "directionline": "why-shankar-ias-module__RMjqfa__directionline",
  "img": "why-shankar-ias-module__RMjqfa__img",
  "normalbutton1": "why-shankar-ias-module__RMjqfa__normalbutton1",
  "pagemaintitle": "why-shankar-ias-module__RMjqfa__pagemaintitle",
  "redunderline": "why-shankar-ias-module__RMjqfa__redunderline",
  "whyboxboxheight": "why-shankar-ias-module__RMjqfa__whyboxboxheight",
});
